/** Csoport-kedvezmény — közös feliratok (kosár, pénztár, kosár-állapot). A backend párja:
 * customer_groups/pricing.py (GROUP_DISCOUNT_LABEL, GROUP_COUPON_BLOCKED_MESSAGE). */

/** Az összesítő sorának alapfelirata (a szerver címkéje: „Csoport-kedvezmény (OMTK-ULE)”). */
export const GROUP_DISCOUNT_LABEL = 'Csoport-kedvezmény';

/** Segédszöveg a kuponmezőnél, ha a kosárban csoport-kedvezményes tétel van. */
export const GROUP_COUPON_HINT = 'Csoport-kedvezménnyel csak GT Pont kupon használható.';

/** Jelzés, ha az alkalmazott (nem GTP) kupont a csoport-kedvezmény miatt levettük. */
export const GROUP_COUPON_REMOVED_NOTICE = 'A kupont eltávolítottuk: csoport-kedvezménnyel nem használható.';
